import { Markdown } from "#components/Markdown";
import { Paragraph, Text } from "#components/Text";
import { Fragment, useEffect, useRef } from "react";

export const Cascade0 = ({ text }: { text: string }) => {
  const lines = text.trim().split("\n");

  return (
    <Paragraph>
      {lines.map((line, i) => (
        <Fragment key={i}>
          <Text as="span" marginLeft={`${i}em`}>
            <Markdown content={line} inline />
          </Text>
          <br />
        </Fragment>
      ))}
    </Paragraph>
  );
};

const getRect = (el: HTMLElement, showRect = false) => {
  const range = document.createRange();
  range.selectNodeContents(el);
  const rect = Array.from(range.getClientRects()).at(-1)!;

  if (showRect) {
    const rectEl = document.createElement("div");
    document.body.appendChild(rectEl);
    rectEl.style.position = "fixed";
    rectEl.style.left = `${rect.left}px`;
    rectEl.style.top = `${rect.top}px`;
    rectEl.style.width = `${rect.width}px`;
    rectEl.style.height = `${rect.height}px`;
    rectEl.style.backgroundColor = "red";
    rectEl.style.opacity = "0.5";
  }

  return rect;
};

const cascadeElts = (els: HTMLElement[]) => {
  const base = els[0].getBoundingClientRect();
  let goingRight = true;

  for (let i = 0; i < els.length - 1; i++) {
    const prev = getRect(els[i]);
    const next = getRect(els[i + 1]);

    if (
      goingRight
        ? prev.right + next.width > base.right
        : prev.left - next.width < base.left
    ) {
      goingRight = !goingRight;
    }

    els[i + 1].style.marginLeft = goingRight
      ? `${Math.min(prev.right, base.right - next.width) - base.left}px`
      : `${Math.max(prev.left - next.width, base.left) - base.left}px`;
  }
};

export const Cascade1 = (props: { main?: string; text: string }) => {
  const [main, lines] = (() => {
    const lines = props.text.trim().split("\n");
    if (props.main) {
      return [props.main, lines];
    }
    const main = lines.shift()!;
    return [main, lines];
  })();
  const refs = useRef<HTMLElement[]>([]);
  const initial = useRef(false);

  useEffect(() => {
    if (refs.current.length === 0) return;

    const listener = () => {
      cascadeElts(refs.current);
    };

    if (!initial.current) {
      initial.current = true;
      listener();
    }

    window.addEventListener("resize", listener);

    return () => {
      window.removeEventListener("resize", listener);
    };
  }, []);

  return (
    <>
      <Text
        ref={(el) => {
          refs.current[0] = el!;
        }}
      >
        <Markdown content={main} inline />
      </Text>
      <Text>
        {lines.map((line, i) => (
          <Fragment key={i}>
            <Text
              as="span"
              width="fit-content"
              ref={(el) => {
                refs.current[i + 1] = el!;
              }}
            >
              <Markdown content={line} inline />
            </Text>
            <br />
          </Fragment>
        ))}
      </Text>
    </>
  );
};
